export default {
  rawData: {
    search: {
      productClass: '商品/原料',
      productCode: '原料编号',
      productName: '原料名称',
      productType: '主料/辅料',
      productCategory: '原料大类',
      productConfirmName: '校准名称',
      productStatus: '数据状态',
      projectCode: '项目编号',
      projectName: '项目名称',
      costType: '成本类型',
      companyCode: '公司编号',
      companyName: '公司名',
      confimProductNameSpec: '校准名称（型号）',
      departmentName: '部门名',
      gmtCreate: '创建时间',
      createBy: '创建人',
      productSpec: '规格型号',
    },
    label: {
      productClass: '商品/原料',
      productCode: '原料编号',
      productName: '原料名称',
      productType: '主料/辅料',
      productCategory: '原料大类',
      productConfirmName: '校准名称',
      productStatus: '数据状态',
      projectCode: '项目编号',
      projectName: '项目名称',
      costType: '成本类型',
      companyCode: '公司编号',
      companyName: '公司名',
      confimProductNameSpec: '校准名称（型号）',
      departmentName: '部门名',
      gmtCreate: '创建时间',
      createBy: '创建人',
      productSpec: '规格型号',
    },
    form: {
      basicDetailInfo: '基本信息',
      basicDetailPct: '校准名称行项目',
    },
    table: {
      projectCode: '行项目号',
      productConfirmName: '校准名称',
      confimProductNameSpec: '校准型号',
    },
    buttons: {
      error: 'Operation failed!',
      confirm: 'Confirm',
      save: '保存',
      submit: '提交',
      revert: '撤销',
      add: '增加',
      delete: '删除',
    },
    message: {
      noData: '您还未选择任何数据',
      pleaseSelectOne: '请选择一条数据操作',
      topFormCheckResult: '请您将数据填写完整',
      deleteSuccess: '删除成功',
      baseDataIncomplete: '请将基本数据填写完整',
      salesDataIncomplete: '请将销售数据填写完整',
      purchasingDataIncomplete: '请将采购数据填写完整',
      is_expand_apply: '数据已存在，是否扩展申请',
      return_list_page: '返回合作伙伴主数据页面',
      data_repeat: '已存在该数据',
      cancelled: '已取消',
      canNotChange: '该数据状态不可编辑',
      enable_to_forbid: '启用只针对已禁用的状态',
      forbid_to_enable: '禁用只针对已生效的状态',
      delete_to_enable: '删除只针对非生效的状态',
      merge_need_enable: '合并功能针对已生效的数据',
      saveSuccess: '保存成功',
      productNameRepeat: '校准名称行项目不能重复',
    },
    placeholder: {
      productClass: '商品/原料',
      productCode: '原料编号',
      productName: '原料名称',
      productType: '主料/辅料',
      productCategory: '原料大类',
      productConfirmName: '请输入校准名称',
      // confimProductNameSpec : '请输入校准型号',
      productStatus: '数据状态',
      projectCode: '项目编号',
      projectName: '项目名称',
      costType: '成本类型',
      companyCode: '公司编号',
      companyName: '公司名',
      confimProductNameSpec: '校准名称（型号）',
      departmentName: '部门名',
      gmtCreate: '创建时间',
      createBy: '创建人',
      productSpec: '规格型号',
    },
    pages: {
      rawDataAdd: '原料主数据新增',
      rawDataList: '原料主数据',
    },
  },
};
